import React from 'react'
import PropTypes from 'prop-types'

import { isEmpty, map } from 'lodash'
import { makeStyles } from '@material-ui/core/styles'
import { ErrorBoundary } from '@scoir/error-reporter'
import { Box, Table, TableBody, TableCell, TableContainer, TableRow, TableHead, Paper } from '@material-ui/core'
import { format } from 'date-fns'

export const useStyles = makeStyles({
  table: {
    minWidth: 650,
  },
  emptyState: {
    width: '100%',
  },
})

const MatchTableUploads = ({ uploads = [] }) => {
  const classes = useStyles()
  return (
    <React.Fragment>
      {isEmpty(uploads) ? (
        <Paper data-testid="empty-state">
          <Box
            className={classes.emptyState}
            display="flex"
            alignItems="center"
            justifyContent="center"
            p={3}
          >
            No Uploads Available...
          </Box>
        </Paper>
      ) : (
        <TableContainer
          data-testid="table"
          component={Paper}
        >
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell className={classes.tableCell}>
                  <strong>File Name</strong>
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <strong>Uploaded By</strong>
                </TableCell>
                <TableCell className={classes.tableCell}>
                  <strong>Date</strong>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {map(uploads, (row, idx) => (
                <TableRow
                  data-testid={`row-${idx}`}
                  key={idx}
                >
                  <TableCell
                    data-testid="file"
                    className={classes.tableCell}
                  >
                    {row.fileName}
                  </TableCell>
                  <TableCell
                    data-testid="user"
                    className={classes.tableCell}
                  >
                    {row.uploadedBy}
                  </TableCell>
                  <TableCell
                    data-testid="date"
                    className={classes.tableCell}
                  >
                    <ErrorBoundary>{format(new Date(row.uploadedAt), 'P p')}</ErrorBoundary>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </React.Fragment>
  )
}

MatchTableUploads.propTypes = {
  uploads: PropTypes.array,
}

export default MatchTableUploads
